import { useTranslate } from "ra-core";

import type { DeskNavLabel } from "./navConfig";

/** Lucide stroke width of the desktop shell. */
export const ICON_STROKE = 1.5;

/** Resolves a nav label (i18n key or literal configuration text). */
export const useNavLabel = () => {
  const translate = useTranslate();
  return (label: DeskNavLabel): string =>
    "text" in label ? label.text : translate(label.key, label.args);
};
